import React from 'react';
import { FastFingersGuide } from './FastFingersGuide';

export interface FastFingersHostProps {
  successEmoji: string;
  wrongEmojis: string[];
  successPoints: number;
  wrongPenalty: number;
  timeLimit: number;
  /** When true, round has ended — hide emoji display so it doesn't overlap with outro. */
  roundEnded?: boolean;
}

/**
 * Host view: displays the success emoji, wrong emojis, and scoring rules.
 * Visual guide for spectators while players tap on their screens.
 * When roundEnded, hides to make room for the "Bonus Level Finished" outro.
 */
export const FastFingersHost: React.FC<FastFingersHostProps> = ({
  successEmoji,
  wrongEmojis,
  successPoints,
  wrongPenalty,
  roundEnded = false,
}) => {
  if (roundEnded) return null;

  return (
    <div
      style={{
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        flex: '1 1 auto',
        minHeight: 0,
      }}
    >
      <FastFingersGuide
        successEmoji={successEmoji}
        wrongEmojis={wrongEmojis}
        successPoints={successPoints}
        wrongPenalty={wrongPenalty}
      />
    </div>
  );
};
